<template>
    <div>
        <div
            ref="augmentedRealityHolder"
            class="content-widget ar-widget"
        />
    </div>
</template>

<script>
    import Http from '@/api/data';
    import { EventBus } from '@/event-bus';

    export default {
        name: "AugmentedRealityWidget",
        props: {
            arUrl: {
                type: String,
                required: true
            },
            active: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                widget: null
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            render() {
                Http.getData(this.$props.arUrl).then(payload => {
                    if (payload) {
                        var widgetData = {
                            'glbFile': payload.AR.android,
                            'usdzFile': payload.AR.ios,
                            'prompt': payload.AR.poster,
                            'message': 'Afficher en réalité augmentée dans votre espace'
                        }
                        this.widget = new Habiteo.AugmentedRealityWidget(this.$refs.augmentedRealityHolder, widgetData);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                    console.log(error)
                });
            }
        },
        watch: {
            active() {
                if (this.active)
                    this.render();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/AugmentedRealityWidget.vue